import request from "@/CommonDP/utils/request";
export default {
  prjNoticeList(params) {
    return request.post(`/prjNotice/list`, params)
      .then(res => res);
  },
  prjNoticeAdd(params) {
    return request.post(`/prjNotice/add`, params)
      .then(res => res);
  },
  prjNoticeDelete (params) {
    return request.post(`/prjNotice/delete`, params)
      .then(res => res);
  },
  prjNoticeDisable(params) {
    return request.post(`/prjNotice/disable`, params)
      .then(res => res);
  },
  prjNoticeUpdate(params) {
    return request.post(`/prjNotice/update`, params)
      .then(res => res);
  },
  prjNoticeGet(noticeId) {
    return request.get(`/prjNotice/get?noticeId=` + noticeId)
      .then(res => res);
  },
  noticeReadRecordAdd(params) {
    return request.post(`/prjNotice/noticeReadRecord/add`, params)
      .then(res => res);
  },
  docGetFolderId(params) {
    return request.post(`/doc/getFolderId`, params);
  },
  prjNoticeGetNoticeNum(enterpriseId, prjId) {
    return request.get(`/prjNotice/getNoticeNum?enterpriseId=` + enterpriseId + '&prjId=' + prjId)
      .then(res => res);
  },
  prjNoticeUserList(params) {
    return request.post(`/prjNotice/userList`, params)
      .then(res => res);
  }
};
